import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";

const useGetJarvisAiManualTitle = (
    orderId: number,
    intentSearch: string,
    extraPlanInformation: string,
    initialRequest = true
) => {
    const [aiManualTitle, setManualTitle] = useState<string>("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = (set?: React.Dispatch<React.SetStateAction<any>>) => {
        setLoading(true);
        OrderTransport.getAiManualTitle(orderId, intentSearch, extraPlanInformation)
            .then((res) => {
                setManualTitle(res);
                set && set(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!orderId) return;
        if (!loading) fetch();
    };

    const setter = (set: React.Dispatch<React.SetStateAction<any>>) => {
        if (!orderId) return;
        if (!loading) fetch(set);
    };

    useEffect(() => {
        if (initialRequest) fetch();
    }, []);

    return { aiManualTitle, refresh, setter, error, loading };
};

export default useGetJarvisAiManualTitle;
